import * as NavigationMenuPrimitive from '@radix-ui/react-navigation-menu'
import { Link } from '@remix-run/react'
import { type ElementRef, forwardRef, type ComponentPropsWithoutRef } from 'react'
import { cn } from '#app/utils/tailwind-merge.ts'

/* NavigationMenu */
const NavigationMenu = forwardRef<ElementRef<typeof NavigationMenuPrimitive.Root>, ComponentPropsWithoutRef<typeof NavigationMenuPrimitive.Root>>(
	({ className, children, ...props }, ref) => (
		<NavigationMenuPrimitive.Root ref={ref} {...props}>
			<NavigationMenuPrimitive.List className={cn('gap-space-6 flex items-stretch', className)}>{children}</NavigationMenuPrimitive.List>
		</NavigationMenuPrimitive.Root>
	),
)
NavigationMenu.displayName = NavigationMenuPrimitive.Root.displayName

/* NavigationMenuItem */
const NavigationMenuItem = forwardRef<ElementRef<typeof NavigationMenuPrimitive.Item>, ComponentPropsWithoutRef<typeof NavigationMenuPrimitive.Item>>(({ className, ...props }, ref) => (
	<NavigationMenuPrimitive.Item ref={ref} className={cn('flex items-stretch', className)} {...props} />
))
NavigationMenuItem.displayName = NavigationMenuPrimitive.Item.displayName

/* NavigationMenuLink */
const NavigationMenuLink = forwardRef<ElementRef<typeof NavigationMenuPrimitive.Link>, ComponentPropsWithoutRef<typeof NavigationMenuPrimitive.Link> & { href: string }>(
	({ className, children, ...props }, ref) => (
		<NavigationMenuPrimitive.Link ref={ref} className={cn('px-space-6 py-space-4', className)} {...props} asChild>
			<Link to={props.href}>{children}</Link>
		</NavigationMenuPrimitive.Link>
	),
)
NavigationMenuLink.displayName = NavigationMenuPrimitive.Link.displayName

/* NavigationMenuTrigger */
const NavigationMenuTrigger = forwardRef<ElementRef<typeof NavigationMenuPrimitive.Trigger>, ComponentPropsWithoutRef<typeof NavigationMenuPrimitive.Trigger>>(
	({ className, children, ...props }, ref) => (
		<NavigationMenuPrimitive.Trigger ref={ref} className={cn('gap-space-5 px-space-6 py-space-4 flex items-baseline', className)} {...props}>
			{children}
		</NavigationMenuPrimitive.Trigger>
	),
)
NavigationMenuTrigger.displayName = NavigationMenuPrimitive.Trigger.displayName

/* NavigationMenuContent */
const NavigationMenuContent = forwardRef<ElementRef<typeof NavigationMenuPrimitive.Content>, ComponentPropsWithoutRef<typeof NavigationMenuPrimitive.Content>>(
	({ className, ...props }, ref) => (
		<NavigationMenuPrimitive.Content
			ref={ref}
			className={cn(
				'bg-background p-space-6 data-[motion^=from-]:animate-in data-[motion^=to-]:animate-out data-[motion^=from-]:fade-in data-[motion^=to-]:fade-out data-[motion=from-end]:slide-in-from-left-52 data-[motion=from-start]:slide-in-from-right-52 data-[motion=to-end]:slide-out-to-left-52 data-[motion=to-start]:slide-out-to-right-52 top-[calc(100%+9px)] w-full rounded-lg border shadow-lg md:absolute md:w-auto',
				className,
			)}
			{...props}
		/>
	),
)
NavigationMenuContent.displayName = NavigationMenuPrimitive.Content.displayName

/* NavigationMenuIndicator */
const NavigationMenuIndicator = NavigationMenuPrimitive.Indicator

export { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuTrigger, NavigationMenuContent, NavigationMenuIndicator }
